import { registerDataTableComponent } from '@vendure/admin-ui/core';
import { CustomerProfileColumnComponent } from './customer-profile-column.component';

export default [
    registerDataTableComponent({
        component: CustomerProfileColumnComponent,
        tableId: 'customer-list',
        columnId: 'profileAnalysis',
    }),
];
